export const PLANOGRAM_SCALE = 1 / 100;
export const PLANOGRAM_FRONT_MIN_ZOOM = 0.6;
export const PLANOGRAM_FRONT_MAX_ZOOM = 5;
export const PLANOGRAM_FRONT_ZOOM_SPEED = 0.003;
